import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getReelRankingList = (rankingData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_REEL_RANKING_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/reels/reels-ranking-list`,
        rankingData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_REEL_RANKING_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_REEL_RANKING_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_REEL_RANKING_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const updateReelRanking = (rankingData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_REEL_RANKING_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/reels/update-reels-ranking`,
        rankingData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_REEL_RANKING_SUCCESS", payload: data });
        // toast.success("Ranking Updated Successfully!!");
        return data;
      } else {
        dispatch({ type: "UPDATE_REEL_RANKING_FAILED", payload: data });
        // toast.error("Something Went Wrong!!");
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_REEL_RANKING_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


